import { Intl } from "../utils/intl.mjs";
const getLocaleName = (displayLocale, targetLocale = displayLocale) => {
  let displayNames = new Intl.DisplayNames(targetLocale, {
    type: "language"
  });
  return displayNames.of(displayLocale) ?? "Unknown locale";
};
export {
  getLocaleName
};
//# sourceMappingURL=getLocaleName.mjs.map